import { accountHistorySagaWorkers } from '../../accountHistory/AccountHistory.sagas';
import { dashboardSagaWorkers } from '../../dashboard/Dashboard.sagas';
import { earlyRepaymentSagaWorkers } from '../../earlyRepayment/EarlyRepayment.sagas';
import { addPaymentMethodModalSagaWorkers } from '../../modals/addPaymentMethodModal/AddPaymentMethodModal.sagas';
import { editDebitCardSagaWorkers } from '../../modals/editPaymentMethodModal/EditPaymentMethodModal.sagas';
import { manualPaymentModalSagasWorkers } from '../../modals/manualPaymentModal/ManualPaymentModal.sagas';
import { onfidoVerificationWorkers } from '../../modals/onfidoVerificationModal/OnfidoVerificationModal.sagas';
import { personModalSagasWorkers } from '../../modals/personModal/PersonModal.sagas';
import { linkOpenBankingModalWorkers } from '../../modals/linkOpenBankingModal/LinkOpenBankingModal.sagas';
import { processingPaymentModalSagasWorkers } from '../../modals/processingPaymentModal/ProcessingPaymentModal.sagas';
import { repaymentScheduleSagasWorkers } from '../../modals/repaymentScheduleModal/RepaymentScheduleModal.sagas';
import { uploadDocumentsModalSagaWorkers } from '../../modals/uploadDocumentsModal/UploadDocumentsModal.sagas';
import { pageNotFoundSagaWorkers } from '../../pageNotFound/PageNotFound.sagas';
import { tradingDataSagaWorkers } from '../../tradingData/TradingData.sagas';
import { profileSagaWorkers } from '../../Profile/Profile.sagas';
import { SecondCBILSDashboardSagasWorkers } from '../../CBILS/secondCBILSDashboard/SecondCBILSDashboard.sagas';
import { navigationSagaWorker } from '../../navigation/Navigation.sagas';
import { applyFlexiLoanSagasWorker } from '../../applyFlexiLoanView/ApplyFlexiLoanView.sagas';
import { RLSDashboardSagasWorkers } from '../../RLS/dashboard/Dashboard.sagas';
import { RBLDashboardSagaWorkers } from '../../revenueBasedLoan/dashboard/Dashboard.sagas';
import { Flexi24DashboardSagaWorkers } from '../../flexi24/dashboard.saga';
import { myOffersSagaWorkers } from '../../myOffers/MyOffers.sagas';
import { iwocaPayDashboardSagaWorkers } from '../../iwocaPay/dashboard/Dashboard.sagas';
import { TermLoanDashboardSagaWorkers } from '../../termLoan/Dashboard.sagas';
import { fundingStepsSagaWorkers } from '../../funding/fundingSteps/FundingSteps.sagas';
import { confirmFundingSagaWorkers } from '../../funding/ConfirmFundingView/ConfirmFunding.sagas';
import { outstandingSaga } from '../../multiLoanDashboard/OutstandingView/OutstandingView.sagas';

export const mainContentSagaWorkers = [
    ...pageNotFoundSagaWorkers,
    ...dashboardSagaWorkers,
    ...accountHistorySagaWorkers,
    ...tradingDataSagaWorkers,
    ...profileSagaWorkers,
    ...earlyRepaymentSagaWorkers,
    ...addPaymentMethodModalSagaWorkers,
    ...editDebitCardSagaWorkers,
    ...personModalSagasWorkers,
    ...linkOpenBankingModalWorkers,
    ...manualPaymentModalSagasWorkers,
    ...processingPaymentModalSagasWorkers,
    ...repaymentScheduleSagasWorkers,
    ...uploadDocumentsModalSagaWorkers,
    ...onfidoVerificationWorkers,
    ...SecondCBILSDashboardSagasWorkers,
    ...RLSDashboardSagasWorkers,
    ...Flexi24DashboardSagaWorkers,
    ...RBLDashboardSagaWorkers,
    ...iwocaPayDashboardSagaWorkers,
    ...TermLoanDashboardSagaWorkers,
    ...navigationSagaWorker,
    ...applyFlexiLoanSagasWorker,
    ...myOffersSagaWorkers,
    ...fundingStepsSagaWorkers,
    ...confirmFundingSagaWorkers,
    ...outstandingSaga
];
